// todo: оптимизировать вызовы функций

const applyBrightness = (adjust, { r, g, b }) => {
  const brightness = Math.floor(255 * (adjust / 100))

  r += brightness
  g += brightness
  b += brightness

  return { r, g, b }
}

const applyContrast = (adjust, { r, g, b }) => {
  const contrast = Math.pow((adjust + 100) / 100, 2)

  let red = r
  red /= 255
  red -= 0.5
  red *= contrast
  red += 0.5
  red *= 255
  r = red

  let green = g
  green /= 255
  green -= 0.5
  green *= contrast
  green += 0.5
  green *= 255
  g = green

  let blue = b
  blue /= 255
  blue -= 0.5
  blue *= contrast
  blue += 0.5
  blue *= 255
  b = blue

  return { r, g, b }
}

const applySaturation = (adjust, { r, g, b }) => {
  const saturation = adjust * -0.01
  const max = Math.max(r, g, b)

  if (r !== max) r += (max - r) * saturation
  if (g !== max) g += (max - g) * saturation
  if (b !== max) b += (max - b) * saturation

  return { r, g, b }
}

const applyColorFilter = (adjust, { xR, xG, xB, r, g, b }) => {
  r -= (r - xR) * adjust
  g -= (g - xG) * adjust
  b -= (b - xB) * adjust

  return { r, g, b }
}

const applyRGBAdjust = ({ xR, xG, xB, r, g, b }) => {
  r *= xR
  g *= xG
  b *= xB

  return { r, g, b }
}

const applyOpacity = (opacity, { cloneR, cloneG, cloneB, cloneA }, { r, g, b }) => {
  r = cloneR - (cloneR - r) * ((opacity / 100) * (cloneA / 255))
  g = cloneG - (cloneG - g) * ((opacity / 100) * (cloneA / 255))
  b = cloneB - (cloneB - b) * ((opacity / 100) * (cloneA / 255))

  return { r, g, b }
}

export const Filters = {
  grayscale: (opacity, { r, g, b, a }) => {
    const cloneR = r
    const cloneG = g
    const cloneB = b
    const cloneA = a

    let luminance = 0.299 * r + 0.587 * g + 0.114 * b

    r = luminance
    g = luminance
    b = luminance

    const rgb = applyOpacity(opacity, { cloneR, cloneG, cloneB, cloneA }, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    return { r, g, b }
  },
  dogpatch: (opacity, { r, g, b, a }) => {
    const cloneR = r
    const cloneG = g
    const cloneB = b
    const cloneA = a

    let rgb = applyContrast(38, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    rgb = applySaturation(-15, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    rgb = applyBrightness(8, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    rgb = applyOpacity(opacity, { cloneR, cloneG, cloneB, cloneA }, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    return { r, g, b }
  },
  aden: (opacity, { r, g, b, a }) => {
    const cloneR = r
    const cloneG = g
    const cloneB = b
    const cloneA = a

    let rgb = applyColorFilter(0.05, { xR: 228, xG: 130, xB: 225, r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    rgb = applySaturation(-5, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    rgb = applyOpacity(opacity, { cloneR, cloneG, cloneB, cloneA }, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    return { r, g, b }
  },
  hudson: (opacity, { r, g, b, a }) => {
    const cloneR = r
    const cloneG = g
    const cloneB = b
    const cloneA = a

    let rgb = applyRGBAdjust({ xR: 1, xG: 1, xB: 1.15, r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    rgb = applyOpacity(opacity, { cloneR, cloneG, cloneB, cloneA }, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    return { r, g, b }
  },
  perpetua: (opacity, { r, g, b, a }) => {
    const cloneR = r
    const cloneG = g
    const cloneB = b
    const cloneA = a

    let rgb = applyRGBAdjust({ xR: 1.05, xG: 1.1, xB: 1, r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    rgb = applyOpacity(opacity, { cloneR, cloneG, cloneB, cloneA }, { r, g, b })
    r = rgb.r
    g = rgb.g
    b = rgb.b

    return { r, g, b }
  },
  applyFilter: (filterId, opacity, imageData) => {
    const filter = Filters[filterId]
    const length = imageData.data.length

    for (let i = 0; i < length; i = i + 4) {
      let r = imageData.data[i]
      let g = imageData.data[i + 1]
      let b = imageData.data[i + 2]
      let a = imageData.data[i + 3]

      const rgb = filter(opacity, { r, g, b, a })

      imageData.data[i] = rgb.r
      imageData.data[i + 1] = rgb.g
      imageData.data[i + 2] = rgb.b
    }

    return imageData
  }
}

export const applyAdjustAndFilters = (imageData, adjust, filters) => {
  for (let i = 0; i < imageData.data.length; i = i + 4) {
    let r = imageData.data[i]
    let g = imageData.data[i + 1]
    let b = imageData.data[i + 2]
    let a = imageData.data[i + 3]

    if (adjust) {
      if (adjust.values.brightness) {
        const rgb = applyBrightness(adjust.values.brightness, { r, g, b })
        r = rgb.r
        g = rgb.g
        b = rgb.b
      }

      if (adjust.values.contrast) {
        const rgb = applyContrast(adjust.values.contrast, { r, g, b })
        r = rgb.r
        g = rgb.g
        b = rgb.b
      }

      if (adjust.values.saturation) {
        const rgb = applySaturation(adjust.values.saturation, { r, g, b })
        r = rgb.r
        g = rgb.g
        b = rgb.b
      }
    }

    if (filters) {
      if (filters.values.grayscale) {
        const rgb = Filters.grayscale(filters.values.grayscale, { r, g, b, a })
        r = rgb.r
        g = rgb.g
        b = rgb.b
      }

      if (filters.values.dogpatch) {
        const rgb = Filters.dogpatch(filters.values.dogpatch, { r, g, b, a })
        r = rgb.r
        g = rgb.g
        b = rgb.b
      }

      if (filters.values.aden) {
        const rgb = Filters.aden(filters.values.aden, { r, g, b, a })
        r = rgb.r
        g = rgb.g
        b = rgb.b
      }

      if (filters.values.hudson) {
        const rgb = Filters.hudson(filters.values.hudson, { r, g, b, a })
        r = rgb.r
        g = rgb.g
        b = rgb.b
      }

      if (filters.values.perpetua) {
        const rgb = Filters.perpetua(filters.values.perpetua, { r, g, b, a })
        r = rgb.r
        g = rgb.g
        b = rgb.b
      }
    }

    imageData.data[i] = r
    imageData.data[i + 1] = g
    imageData.data[i + 2] = b
  }

  return imageData
}
